import commonConstants from "./commonConstants";

export default {
  APP_KEY: "COM",
  KEY: "2mwTEDr9zXJH323M",
  SPECIAL_URL: "https://static.smartstake.io/special/",
  PROJECT_LOGO_BASE_URL: "https://static.smartstake.io/",
  HOME_KEY: "HOME_KEY_V0",
  DEFAULT_HOME_URL: "/relayers",
  app: {
    title: "Interchain Relayer Analytics",
    appName: "Relayers",
    defaultLogo: "/images/chains/cosmos.jpg",
    defaultProjectLogo: "/images/chains/relayer.png",
    VALIDATORS_KEY: commonConstants.basic.baseKeyForValidators + "_V1",
    DEFAULT_POOL_ID: 1,
    adEnabled: false,
  },
  ui: {
    beta: false,
  }
};
